// Типы для проверки целостности данных
export const dataIntegrityEndpoints = {
    verifyStatsIntegrity: {
        query: (params?: { offset?: number; limit?: number }) => ({
            url: "/admin/dashboard/verify-stats-integrity",
            method: "POST",
            params,
        }),
    },

    fixStatsIntegrityUser: {
        query: (userId: number) => ({
            url: `/admin/dashboard/fix-stats-integrity-user`,
            method: "POST",
            body: { user_id: userId },
        }),
    },

    getStatsIntegrityUserDetails: {
        query: (args: {
            user_id: number;
            currency: "USD" | "USDT" | 0 | 1;
        }) => ({
            url: "/admin/dashboard/stats-integrity-user-details",
            params: args,
        }),
    },
};

export const dataIntegrityTags = ["DataIntegrity"] as const;
